import Vue from "vue";
import set from "lodash/set";
import get from "lodash/get";
import { AdobeFunctions } from "./utils/adobeFunctions";
import { nombreMotorTagging } from "@/utils";

const Adobe = {
  enable() {},
  wait() {
    return !!window._satellite && document.readyState !== "complete";
  },
  init(context) {
    AdobeFunctions.internal(context, () => {
      Vue.$log.info("🚀 Adobe Launch working");
    });
  },
  appStarted(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("1 inicio");
      AdobeFunctions.setCommonProductAttributes();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding car insurance simulator"
      );
      set(
        window.digitalData,
        "application.step",
        get(context.mutation.payload, "appStep", "")
      );
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalLink", "App Started");
    });
  },
  appOnClickStart(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setCommonProductAttributes(
        get(context.mutation.payload, "precio", "")
      );
      AdobeFunctions.tienePatente(context);
      AdobeFunctions.setApplicationProps(
        "contratacion",
        "contratar seguro automotor",
        "vehicle insurance"
      );
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalLink", "App On Click Start");
    });
  },
  errorPage(context) {
    switch (context.mutation.payload.params.mje) {
      case "mensaje-0":
      case "mensaje-4":
        AdobeFunctions.internal(context, () => {
          AdobeFunctions.clearVars();
          AdobeFunctions.setPageName("error servicio");
          set(window.digitalData, "page.pageInfo.level1", "seguros");
          set(window.digitalData, "page.pageInfo.level4", "error servicio");
          set(window.digitalData, "page.pageInfo.errorPage", "error servicio");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
        });
        break;
    }
  },
  verificacion(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setCommonProductAttributes("mostrarState", "rechazado");
      AdobeFunctions.setApplicationProps(
        "contratacion",
        "contratar seguro automotor",
        "vehicle insurance"
      );
      set(window.digitalData, "application.state", "rechazado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "transaccion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      set(window.digitalData, "user.segment.profile", "usuario no cliente");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  internalLink(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName(get(context.mutation.payload, "level2", ""));
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      set(
        window.digitalData,
        "page.pageActivity.link.name",
        get(context.mutation.payload, "name", "")
      );
      AdobeFunctions.callAdobeDTM("digitalLink", "Internal Link");
    });
  },
  quieroquemecontacten(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName(get(context.mutation.payload, "level2", ""));
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  paso1(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("1 inicio");
      AdobeFunctions.setCommonProductAttributes();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding car insurance simulator"
      );
      set(window.digitalData, "application.step", "1 inicio");
      set(window.digitalData, "application.isQualifiedVisits", "true");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "App Page Visit");
    });
  },
  paso2(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("2 patente");
      AdobeFunctions.setCommonProductAttributes();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding car insurance simulator"
      );
      set(window.digitalData, "application.step", "2 patente");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  guardado(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("3 guardado del vehiculo");
      AdobeFunctions.setCommonProductAttributes();
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding car insurance simulator"
      );
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      set(window.digitalData, "application.step", "3 guardado del vehiculo");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  cotizacion_planes(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.tienePatente(context);
      AdobeFunctions.setCommonProductAttributes("mostrarState", "finalizado");
      AdobeFunctions.setApplicationProps(
        "simulador",
        nombreMotorTagging(),
        "onboarding car insurance simulator"
      );
      set(window.digitalData, "application.state", "finalizado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  resumen(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("datos");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  condicion(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("condicion del auto");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  marca(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("marca del auto");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  modelo(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("modelo del auto");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  version(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("version del auto");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  gnc(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("equipo gnc");
      set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
      set(window.digitalData, "page.pageInfo.level1", "cotizador vehicular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  }
};

export default Adobe;
